import styled, { keyframes } from "styled-components";
import { DESKTOP_MEDIA_QUERY } from "../constants";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const boxIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-150px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.6);
  text-align: center;
  color: #fff;
  animation: ${fadeIn} 0.3s;
  z-index: 10;
`;

export const ScoreBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  width: 208px;
  height: 208px;
  background-color: #0000ff;
  animation: ${boxIn} 0.3s;
`;

export const ScoreTop = styled.div`
  width: 100%;
  font-size: 96px;
  font-weight: bold;
`;

export const ScoreBottom = styled.div`
  width: 100%;
  margin-top: -10px;
  font-size: 36px;
  font-weight: 300;
`;
